/*
	Menú académico juntado (Horarios Claros, 2026-11-01): pantallas que ahora son pestañas de otra salen UNA vez.
	- Cursos = Cursos (9) + Módulos (10).
	- Calendario Académico = Periodos (12) + Asuetos (56).
	- Aulas = Aulas (16) + Edificios (17).
	Las rutas viejas siguen vivas (el backend revisa permisos por ruta) y abren la pantalla nueva en su pestaña; en el menú sale
	la primera ruta del grupo que la persona tenga con Navegar. Nadie pierde acceso. Los nombres de ct_sections no se tocan.
*/
const NAVEGAR = 1;

export const GRUPOS_ACADEMICOS: { nombre: string; rutas: string[] }[] = [
	{ nombre: "Cursos", rutas: ["courses", "levels"] },
	{ nombre: "Calendario Académico", rutas: ["periods", "academicCalendar"] },
	{ nombre: "Aulas", rutas: ["classrooms", "buildings"] },
];

const puedeNavegar = (permisos: any, ruta: string): boolean =>
	((permisos?.[ruta]?.binary_quintet_RCUDN_permissions || 0) & NAVEGAR) > 0;

const grupoDe = (codigo: string) => GRUPOS_ACADEMICOS.find((g) => g.rutas.includes(codigo));

/** ¿Sale en el menú? Solo la primera ruta de su grupo que la persona pueda abrir. */
export const academicoEnMenu = (codigo: string, permisos: any): boolean => {
	const grupo = grupoDe(codigo);
	if (!grupo) return true;
	return grupo.rutas.find((ruta) => puedeNavegar(permisos, ruta)) === codigo;
};

/** Nombre en el menú de una ruta de estos grupos (undefined = el de ct_sections). */
export const nombreAcademico = (codigo: string): string | undefined => grupoDe(codigo)?.nombre;
